import React from 'react';

const BackIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M14.312 5.244c.387.336.454.905.172 1.318l-.071.093-3.574 4.122 31.684-.058c.552-.001 1 .446 1.002.998 0 .513-.385.936-.882.995l-.117.007-31.323.058 3.225 3.9c.326.395.298.967-.048 1.328l-.086.08c-.395.326-.967.298-1.328-.048l-.08-.086-5.326-6.443L12.9 5.345c.362-.417.994-.462 1.41-.1z" />
  </svg>
);

export default BackIcon;
